var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.175 3.28323C16.8917 6.48323 13.675 10.8332 10.9833 12.9916L9.34167 14.3082C9.13334 14.4582 8.92501 14.5916 8.69167 14.6832C8.69167 14.5332 8.68334 14.3666 8.65834 14.2082C8.56667 13.5082 8.25001 12.8582 7.69167 12.2999C7.12501 11.7332 6.43334 11.3999 5.72501 11.3082C5.55834 11.2999 5.39167 11.2832 5.22501 11.2999C5.31667 11.0416 5.45834 10.7999 5.63334 10.5999L6.93334 8.95823C9.08334 6.26656 13.45 3.03323 16.6417 1.75823C17.1333 1.5749 17.6083 1.70823 17.9083 2.01656C18.225 2.3249 18.375 2.7999 18.175 3.28323Z",
    stroke: "#1F76CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69167 14.6837C8.69167 15.6003 8.34167 16.4753 7.68334 17.142C7.175 17.6503 6.48334 18.0003 5.65834 18.1087L3.60834 18.3337C2.49167 18.4587 1.53334 17.5087 1.66667 16.3753L1.89167 14.3253C2.09167 12.5003 3.61667 11.3337 5.23334 11.3003C5.4 11.292 5.575 11.3003 5.73334 11.3087C6.44167 11.4003 7.13334 11.7253 7.7 12.3003C8.25834 12.8587 8.575 13.5087 8.66667 14.2087C8.675 14.367 8.69167 14.5253 8.69167 14.6837Z",
    stroke: "#1F76CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 12.0579C11.8667 9.88288 10.1 8.11621 7.92499 8.11621",
    stroke: "#1F76CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.9b04896ec8facbc0c4a25f64299ddfae.svg";
export { ForwardRef as ReactComponent };